import qs from 'query-string';

/**
 * 随机字符串
 * @param len 返回值长度
 */
function randomABC(len: number = 10): string {
    const stencil: string = 'qwertyuioplkjhgfdsazxcvbnmQWERTYUIOPLKJHGFDSAZXCVBNM';
    let sum = '';
    for (let i = 0; i < len; i++) {
        sum += stencil.substr(Math.random() * stencil.length, 1);
    }
    return sum;
}

/**
 * 获取url中"?"符后的字串
 * @param url url中"?"符后的字串
 * @param name 参数名
 */
function getQueryString(search: string, name: string) {
    let reg: RegExp = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'); // 匹配目标参数
    let result: string[] = search.substr(1).match(reg); // 对querystring匹配目标参数
    if (result != null) {
        return decodeURIComponent(result[2]);
    } else {
        return null;
    }
}

/** 
 * 获取地址拦参数
 */
function queryStringParse(search: string): any {
    return qs.parse(search);
}

/** 
 * stringify 对象
 * 对象转字符串 name=whitemu&sex=man&sex=women
 */
function stringify(params: object){
    return qs.stringify(params);
}
 
/**
 * 判断是否url (是url返回本身，否则返回null)
 */
function isUrl(url: string): string {
    if(!url){
        return null;
    }

    const arr:string[] = url.match(/^(https?:\/\/)|^(\/\/)(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i);
    if (arr && arr.length >= 1) {
        return url;
    } else {
        return null;
    }
}

export default {

    /** 随机字符串 */
    randomABC,

    /** 获取url中"?"符后的字串 */
    getQueryString,

    /** 获取地址拦参数 */
    queryStringParse,

    /** 判断是否url (是url返回本身，否则返回null) */
    isUrl,

    /** stringify 对象转字符串 name=whitemu&sex=man&sex=women */
    stringify
};



// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/utils/kit/JSString/index.ts